"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortCatalogs = exports.splitCatalogId = void 0;
const libs_utils_1 = require("@hotelplan/libs.utils");
function splitCatalogId(catalogId, idLength = 10) {
    return catalogId.slice(0, idLength);
}
exports.splitCatalogId = splitCatalogId;
function sortCatalogs(catalogs) {
    const catalogsCopy = [...catalogs];
    return catalogsCopy.sort((a, b) => {
        if (splitCatalogId(a.id) === splitCatalogId(b.id)) {
            const { to: aTo } = a;
            const { to: bTo } = b;
            return (0, libs_utils_1.isAfter)((0, libs_utils_1.parseDateStr)(bTo), (0, libs_utils_1.parseDateStr)(aTo)) ? 1 : -1;
        }
        return a.title > b.title ? 1 : -1;
    });
}
exports.sortCatalogs = sortCatalogs;
//# sourceMappingURL=sortCatalogs.js.map